import { render, staticRenderFns } from "./CreateNewPriceCategory.vue?vue&type=template&id=03f76d02"
import script from "./CreateNewPriceCategory.vue?vue&type=script&lang=js"
export * from "./CreateNewPriceCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports